import { selectBuildingsInfoByTypeId } from "../../../../../selectors/selectExistingBuildingInfo";
import { utilBuildings } from "../../../../../utils/utilBuildings";
export var checkBuildingAvailableWithLessThanRequiredLevel = function (path) { return function (action, state$) {
    var state = state$.value;
    var taskType = action.taskType;
    var availableBuildings = selectBuildingsInfoByTypeId(state, taskType.buildingId);
    return availableBuildings.some(function (building) { return utilBuildings.getProtoStage(building) < taskType.stage; })
        ? path
        : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-building/checks/checkBuildingAvailableWithLessThanRequiredLevel.ts
// module id = 2372
// module chunks = 3